<template>
  <div class="mt-6 border-b-4 rounded-md border-polgrey-medium bg-polgrey">
    <div class="px-8 pt-8 pb-4">
      <div class="flex flex-col-reverse mb-4 sm:flex-row">
        <!-- address details -->
        <div class="w-full mt-6 sm:w-1/2 sm:mt-0">
          <p v-for="(line, index) in address" :key="index" class="text-xl leading-7">
            {{ line }}<span v-if="index + 1 < address.length">, </span>
          </p>
          <div class="mt-6">
            <a class="pol-btn hover:bg-polred-dark" role="button" :href="generateBranchLink(branch.fadCode, branch.name)">
              View branch details
            </a>
          </div>
        </div>
        <!-- map & icons -->
        <div class="w-full sm:w-1/2">
          <!-- branch location map -->
          <GmapMap :center="{ lat: branch.latitude, lng: this.branch.longitude }" :zoom="15" map-type-id="terrain" class="w-full h-48">
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="false" @click="center = m.position"
              :icon="{
                url: require('../assets/images/icons/po-marker-highlight.png'),
                scaledSize: { width: 23, height: 40, f: 'px', b: 'px' }
              }"/>
          </GmapMap>
          <div class="flex mt-4 s:mb-0" v-if="branch.services && iconsEnabled">
            <div class="flex-initial pr-2" v-for="icon in branch.services" :key="icon.id">
              <img :src="getIcon(icon.id)" :aria-label="icon.name" :alt="icon.name"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BranchDetails",
  data: () => {
    return {
      iconsEnabled: process.env.VUE_APP_ICONS_ENABLED == "true"
    };
  },
  props: {
    branch: Object
  },
  methods: {
    getIcon: id => {
      try {
        return require(`@/assets/images/icons/${id.toLowerCase().trim()}.gif`);
      } catch (e) {
        return false;
      }
    },
    generateBranchLink: (fadCode, branchName) => {
      return `${
        process.env.VUE_APP_BRANCH_FINDER_BASE_URL
      }/${fadCode.toLowerCase()}/${branchName
        .replace(/\s+/g, "-")
        .toLowerCase()}`;
    }
  },
  computed: {
    address: function() {
      if (!this.branch.address || !this.branch.postcode) {
        return;
      }

      let address = this.branch.address.split(",");
      address.push(this.branch.postcode);

      return address;
    },
    markers: function() {
      return [
        {
          position: {
            lat: this.branch.latitude,
            lng: this.branch.longitude
          }
        }
      ];
    }
  }
};
</script>

<style scoped>
.vue-map-container {
  position: relative;
}

.vue-map-container .vue-map {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
}

.vue-map-hidden {
  display: none;
}
</style>
